export default __webpack_public_path__ + "static/media/logosN4.5912a120.png";